import api from './api.js';

class Notifications {
    constructor(){
        this.url_notifications = 'notifications'
    }

    get(){
        return api.get(`${this.url_notifications}`);
    }
    delete(idArray){
        return api.delete(`${this.url_notifications}`, idArray);
    }
    update(notification){
        return api.put(`${this.url_notifications}`, notification);
    }
}

export default new Notifications;